import { App } from 'antd';
import { addCartItem, addToCart, deleteCartItem, fetchCartItems, removeFromCart, updateCartItem, updateCartItemQuantity } from '../../../store/slices/cartSlice';
import React, { useEffect } from 'react'
import { MdDelete } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'

function ClassicCartItem({ cartItem }) {
    const { modal } = App.useApp();
    const dispatch = useDispatch();
    const isSaving = useSelector(state => state.cartSlice.loading.saving);

    const removeCartItem = () => {
        dispatch(removeFromCart(cartItem));
    }

    return (
        <div className="w-full">
            <div className="flex items-center justify-between border-b py-1 border-gray-300 px-2 gap-1">
                <div className='flex-grow'>
                    <button
                        className="font-bold cursor-pointer"
                        title="View Details"
                    >
                        {cartItem.product.name}
                    </button>
                    {" "}@LKR{cartItem.inventory.price.toFixed(2)}
                </div>
                <div className="flex items-center gap-3 pr-10">
                    <button
                        className={`px-3 py-1 border border-gray-300 ${isSaving || cartItem.quantity === 1 ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                        disabled={isSaving || cartItem.quantity === 1}
                        onClick={() => dispatch(updateCartItemQuantity({ cartItem, quantity: -1 }))}
                        type='button'
                    >
                        -
                    </button>
                    <span>{cartItem.quantity}</span>
                    <button
                        className={`px-3 py-1 border border-gray-300 ${isSaving || cartItem.quantity >= cartItem.inventory.stock ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                        disabled={isSaving || cartItem.quantity >= cartItem.inventory.stock}
                        onClick={() => dispatch(updateCartItemQuantity({ cartItem, quantity: 1 }))}
                        type='button'
                    >
                        + 
                    </button>
                </div>
                <button
                    className="px-3 py-1 border border-red-500 text-red-500 rounded hover:bg-red-500 hover:text-white"
                    onClick={removeCartItem}
                    disabled={isSaving}
                >
                    <MdDelete />
                </button>
            </div>
        </div>
    )
}

export default ClassicCartItem